import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {ArticlePreviewSection} from "../Index/Sections/ArticlePreviewSection";
import {useProfile} from "../../UserProfileProvider";
import {useAuth0} from "@auth0/auth0-react";
import './HomePage.css'
import {BusinessCarousel} from "../ProviderWebsite/ProviderBios";
import {FindProviderRequest, FindProviderResponse, IProviderSearchResult} from "../../compiled";
import {PlaceAutocomplete} from "../Map/PlaceAutocomplete";
import {useRpcSender} from "../../RpcSender";
import {JoinKensu} from "./JoinKensu";

/**
 * The home page right now is only for logged in users, since it's only visible
 * to alpha participants (and thus logged in users). Eventually it's gonna have to
 * switch to handler both logged in and not-logged in users.
 */
export const HomePage = () => {

  const navigate = useNavigate();
  const {profile, profileLoading} = useProfile();
  const {user} = useAuth0();
  const rpcSender = useRpcSender();

  const [featuredBusinesses, setFeaturedBusinesses] = useState<IProviderSearchResult[]>([]);

  // Recommended providers
  useEffect(() => {

    if (!profile) {
      return;
    }

    let request = new FindProviderRequest({
      north: 40.9,
      east: -73.9,
      south: 40.6,
      west: -74.1
    });

    rpcSender.send("find_recommended_providers", FindProviderRequest.encode(request).finish())
        .then(r => {
          let response = FindProviderResponse.decode(r);
          setFeaturedBusinesses(response.providers);
        }).catch(e => {
      setFeaturedBusinesses([]);
    })
  }, [profile])

  // Possible there is a logged in user but no profile. Create if so
  if (user && !profile && !profileLoading) {
    return <JoinKensu/>
  }

  return (<>
    <h1>
      Welcome, {profile?.givenName || user?.given_name}!
    </h1>

    <div>
      Kensu is your personalized wellness hub—where you can easily schedule treatments, connect with expert
      practitioners, and receive tailored insights to support your well-being
    </div>

    <div className={'WelcomeSectionOptions'}>
      <WelcomeSectionOption icon_url={require('../../images/icons/account_box_brown.png')}
                            title={'Find a practitioner'}
                            comingSoon={true}
      />

      <WelcomeSectionOption icon_url={require('../../images/icons/calendar_month_brown.png')}
                            title={'My Bookings'}
                            url={'/dashboard'}/>

      <WelcomeSectionOption icon_url={require('../../images/icons/settings_brown.png')}
                            title={'My Settings'}
                            url={'/dashboard/settings'}/>

      <WelcomeSectionOption icon_url={require('../../images/icons/favorite_brown.png')}
                            title={'Wellness library'}
                            comingSoon={true}
      />

    </div>

    <div className={'AppSection WhiteSection'}>
      <div className={'AppSectionContent RecommendedProvidersSection'}>

        <h1>Kensu Providers</h1>
        <BusinessCarousel businesses={featuredBusinesses}/>
      </div>
    </div>


    {/*<div className={'AppSection OrangeSection'}>*/}
    {/*  <div className={'AppSectionContent MoreRecommendedProvidersSection'}>*/}
    
    {/*    <h1>*/}
    {/*      Find more recommended practitioners near you*/}
    {/*    </h1>*/}
    
    {/*    <PlaceAutocomplete onPlaceSelect={place => {*/}
    {/*      if (place?.geometry?.location) {*/}
    {/*        navigate(`/search?lat=${place.geometry.location.lat()}&lng=${place.geometry.location.lng()}`);*/}
    {/*      }*/}
    {/*    }}/>*/}
    
    {/*  </div>*/}
    {/*</div>*/}

    <ArticlePreviewSection hasGoToWellnessLibraryButton={false}/>
  </>)
}

type WelcomeSectionOptionProps = {
  icon_url: string;
  title: string;
  url?: string;
  comingSoon?: boolean
}

const WelcomeSectionOption = (props: WelcomeSectionOptionProps) => {

  return <Link className={'WelcomeSectionOption'} to={props.url ?? '#'}>
    <img alt={props.title} src={props.icon_url} className={'WelcomeSectionOptionIcon'}/>
    <div className={'HorizontalFlexBox'} style={{alignItems: 'center'}}>{props.title}
      {props.comingSoon && <div className={'WelcomeSectionComingSoon'}>COMING SOON!</div>}
    </div>
  </Link>
}